import React from "react";
import ProductDetailList from "./ProductDetailList";

const ProductDetail = () => <ProductDetailList />;

export default ProductDetail;
